import { environment } from 'src/environments/environment';
import { Menu } from './menu.model';

export const MenuData = [
  new Menu(1, 0, 'Página Principal', '/', null, 'dna-grid', null, false, 0),

  new Menu(2, 0, 'Usuários', null, null, 'dna-users', null, true, 0),
  new Menu(3, 1, 'Usuários', null, environment.sso.web + '/system-user/users', 'dna-user-single', null, false, 2, true),
  new Menu(4, 2, 'Grupo de Usuários', null, environment.sso.web + '/system-user/user-groups', 'dna-user-group', null, false, 2, true),
  new Menu(5, 3, 'Permissões de Segurança', null, environment.sso.web + '/system-user/permissions', 'dna-shield', null, false, 2, true),
  new Menu(6, 4, 'Configurações de senha', null, environment.sso.web + '/system-user/password-settings', 'dna-lock', null, false, 2, true),


  new Menu(7, 0, 'Nota Fiscal', null, null, 'dna-file', null, true, 0),
  new Menu(8, environment.painelNotas, 'Notas fiscais', '/notes', null, 'dna-panel', null, false, 7),
  new Menu(9, environment.extratoConsumo, 'Extrato de Consumo', '/extracts', null, 'dna-receipt', null, false, 7),
  new Menu(10, environment.divergencias, 'Divergências', '/report/divergences', null, 'dna-alert', null, false, 7),
]
